import * as React from 'react';
import '../styles/main.css';
import Button from '../custom_components/button/button.component';
import { StoreState, CustomAction } from '../store';
import { Dispatch, bindActionCreators } from 'redux';
import { selectGeneric } from '../store/actions/generic.actions';
import { Signup_Obj } from '../store/reducers/signup_input.reducers';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { History } from 'history';
import { Signup_Details_Obj } from '../store/reducers/signup_details.reducers';

import * as top_screen_loading from '../assets/img/screens/attendance_loading.png';
import * as top_screen from '../assets/img/screens/attendance.gif';
import * as middle_screen from '../assets/img/screens/report.gif';
import * as bottom_screen from '../assets/img/screens/fingerprints.gif';

import * as profile_light from '../assets/img/screens/profile_light.png';
import * as report_printable from '../assets/img/screens/report_p.png';
import * as report_cards from '../assets/img/screens/report_c.png';
import * as profile_night from '../assets/img/screens/profile_night.gif';

import * as emp_profile from '../assets/img/screens/employee_profile.png';
import * as leave_app from '../assets/img/screens/leave_app.png';
import * as attendance from '../assets/img/screens/attendance.png';

import FeatureImageBlock from '../custom_components/feature_image_block/feature_image_block.component';
import FeatureImageWideBlock from 'src/custom_components/feature_image_wide_block/feature_image_wide_block.component';

// import Button from '../custom_components/button/button.component';

export interface Main_Props {
    signup_form: Signup_Obj;

    updateForm: Function;
}

class Main extends React.PureComponent<Main_Props> {

    title_text = 'Simply practical';
    sub_title_text = 'Reduce manual paperwork, boost office productivity, track attendance, custom-configure almost anything.';
    trial_text = 'Signup for an account and start working right away, no need to request a demo or make a phone call.';

    render() {
        const Submit_Button = withRouter(
            ({history}) => (
                <Button 
                    onClick={this.submitForm.bind(this, history)} 
                    disabled={!this.props.signup_form.valid}
                    text="Try It Free" 
                    color="#673AB7" 
                    text_color="white">
                </Button>
            )
        )

        return (
            <div className="main-window">
                <div className="main-main">
                    <div className="main-cta main-back-color main-shadow">
                        <div className="main-block">
                            <div className="main-cta-form">
                                <h1 className="main-cta-title">{this.title_text}</h1>
                                <div className="main-cta-text-box">
                                    <h2 className="main-cta-sub-title">{this.sub_title_text}</h2>
                                </div>
                                <div className="main-signup-form">
                                    <input 
                                        onChange={this.formInput} 
                                        autoComplete="email" 
                                        className={
                                            'main-signup-input' + (this.props.signup_form.value == '' ? ' pending-input' : (this.props.signup_form.valid ? ' valid-input' : ' invalid-input'))
                                        } 
                                        value={this.props.signup_form.value}
                                        type="email" 
                                        placeholder="Email address" 
                                        name="name"/>
                                    <Submit_Button></Submit_Button>
                                </div>
                                <div className="main-cta-text-box">
                                    <span className="main-cta-warn-text">
                                        {this.props.signup_form.value != '' && !this.props.signup_form.valid ? 'It seems like you have entered an invalid email address' : ''}
                                    </span>
                                </div>
                                <div className="main-cta-text-box">
                                    <span className="main-cta-trial-text">{this.trial_text}</span>
                                </div>
                                <div className="main-signup-form">
                                    <span className="main-cta-trial-text">Already have an account?&nbsp;</span>
                                    <Button 
                                        onClick={() => window.location.href = 'https://home.oneclickhrm.com'}
                                        disabled={false}
                                        text="Login" 
                                        color="#3463ef" 
                                        text_color="white">
                                    </Button>
                                </div>
                            </div>
                        </div>
                        <div className="main-over-block">
                            <div className="main-screen-block">
                                <img src={top_screen} className="main-img main-shadow" alt={top_screen_loading} />
                            </div>
                            <div className="main-screen-block">
                                <img src={middle_screen} className="main-img main-shadow" alt="background" />
                            </div>
                            <div className="main-screen-block">
                                <img src={bottom_screen} className="main-img main-shadow" alt="background" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main-cta-feature-alt">
                    <div className="main-feature-tall-block main-feature-spacing">
                        <div className="main-feature-screen-block">
                            <img src={report_cards} className="main-img main-shadow" alt="background" />
                        </div>
                        <div className="main-feature-screen-block">
                            <img src={report_printable} className="main-img main-shadow" alt="background" />
                        </div>
                    </div>
                    <FeatureImageBlock
                        align="left"
                        title="Advanced Reporting"
                        body="What is the point of organizing your data into a system if it doesn't help you take decisions more efficiently."
                        body2="Graphs, charts, tables, printable data, excel exports."
                        image={middle_screen}>
                    </FeatureImageBlock>
                </div>
                <div className="main-cta-feature">
                    <FeatureImageBlock
                        align="right"
                        title="Flexible"
                        body="As simple or as complex as your organization needs it to be. There are toggles and settings for almost everything."
                        body2="Just configure it."
                        image={profile_light}>
                    </FeatureImageBlock>
                    <FeatureImageBlock
                        align="left"
                        title="Night Mode"
                        body="For those late nights or stormy days. Give your eyes a rest."
                        body2="Enjoy the little things."
                        image={profile_night}>
                    </FeatureImageBlock>
                </div>
                <div className="main-cta-feature main-cta-feature-wide">
                    <FeatureImageWideBlock
                        title="Employee Profiles"
                        body="Decide what you want to store about your employees, manage their login accounts, view demographics."
                        body2=""
                        image={emp_profile}>
                    </FeatureImageWideBlock>
                </div>
                <div className="main-cta-feature main-cta-feature-wide">
                    <FeatureImageWideBlock
                        title="Leave Management"
                        body="Define holidays, approve/deny leave, take leave and view consumption."
                        body2=""
                        image={leave_app}>
                    </FeatureImageWideBlock>
                </div>
                <div className="main-cta-feature main-cta-feature-wide">
                    <FeatureImageWideBlock
                        title="Attendance"
                        body="Assign shifts, upload attendance, absenteeism, tardiness, presence, over-time and other information related to attendance."
                        body2=""
                        image={attendance}>
                    </FeatureImageWideBlock>
                </div>
            </div>
        )
    }

    formInput = (event: any) => {
        let re = new RegExp("[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?");
        let updated_form: Signup_Obj = {
            value: event.target.value,
            valid: re.test(event.target.value)
        }
        this.props.updateForm('SIGNUP_UPDATE', updated_form)
    }

    submitForm = (history: History, event: any) => {
        let fresh_details: Signup_Details_Obj = {
            email: this.props.signup_form.value,
            product: null
        };

        this.props.updateForm('SIGNUP_DETAILS_UPDATE', fresh_details)

        history.push('/signup')
    }
}

export function mapStateToProps({ signup_form, signup_details }: StoreState) {
    return {
      signup_form: signup_form,
      signup_details: signup_details
    }
}
  
export function mapDispatchToProps(dispatch: Dispatch<CustomAction>) {
    return bindActionCreators({
        updateForm: selectGeneric
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Main);


// WEBPACK FOOTER //
// ./src/main/main.component.tsx